import React, {FC, useState} from "react";
import {IYesOrNo as IProps} from "./types";
import cls from '../atoms.module.scss'

const YesNoRadio: FC<IProps> = ({
                                    item,
                                    index,
                                    handleChange,
                                    translationsData,
                                    savedFormData
                                }) => {
    const [checked, setChecked] = useState(true);
    const handleChecking = () => {
        setChecked(false)
    }
    return (
        <div key={index} className={cls["signUp-position-relative"]} style={{marginLeft: "5px"}}>
            <p style={{marginTop: "10px"}}>{item.default_label}</p>
            <div onClick={handleChecking} className={cls["signUp-position-yes-no"]}>
                <input
                    onChange={(e) => handleChange(e, item.validation)}
                    type="radio"
                    id="yes"
                    name={item.attribute_code}
                    value={1}
                    className={cls["signUp-position-yes-input"]}
                    required={!!+item.is_required}
                    // @ts-ignore
                    checked={(checked && savedFormData?.[item.attribute_code] === 1) || null}
                />
                <label htmlFor="yes">Yes</label>
                <input
                    onChange={(e) => handleChange(e, item.validation)}
                    type="radio"
                    id="no"
                    name={item.attribute_code}
                    value={0}
                    className={cls["signUp-position-no-input"]}
                    required={!!+item.is_required}
                    // @ts-ignore
                    checked={(checked && savedFormData?.[item.attribute_code] === 0) || null}
                />
                <label htmlFor="no">No</label>
            </div>
        </div>
    )
}

export default YesNoRadio;